import(/* webpackMode: "eager" */ "/vercel/path0/app/(store)/store/page.tsx");
